module.exports = function(service) {
	'use strict'
	service.factory('authtokenService',authtokenService);
	authtokenService.$inject=['$rootScope','$timeout','$window'];
	function authtokenService($rootScope, $timeout, $window) {
		var storage = $window.localStorage;
		var cachedName;
		var cachedLastName;
		var cachedAvatar;
		var cachedId;
		var cachedroleId;
		var cachedAitools;
		var userToken = 'userToken';
		var refreshToken = 'refreshToken';
		var userName = 'userName';
		var userLastName = 'userLastName';
		var userAvatar = 'userAvatar';
		var userId = 'userId';
		var roleId = 'roleId' 
		var aitools = 'aitools';
		var authToken = {
			setToken:function(token) {
				storage.setItem(userToken, token);
				
			},
			setrefreshToken:function(refreshtoken) {
				storage.setItem(refreshToken, refreshtoken);
			},
			setNameandAvatarandIdandroleId:function(name, lastName, avatar,id,role_id,aitoolsData) {
				cachedName = name;
				cachedLastName = lastName;
				cachedAvatar= avatar;
				cachedId = 	id;
				cachedroleId = role_id;
				cachedAitools = aitoolsData || [];
				storage.setItem(userName, name || '');
				storage.setItem(userLastName, lastName || '');
				storage.setItem(userAvatar, avatar);
				storage.setItem(userId, id);
				storage.setItem(roleId,role_id);
				storage.setItem(aitools,JSON.stringify(aitoolsData || []));
			},
			getToken:function() {
				return storage.getItem(userToken);  
				
			},
			getRefreshToken:function() {
				return storage.getItem(refreshToken);
			},
			getRoleId:function() {
				if(!cachedroleId) {
					cachedroleId = storage.getItem(roleId);
				}
				return cachedroleId;
			},
			getUserId:function() {
				if(!cachedId) {
					cachedId = storage.getItem(userId);
				}
				return cachedId;
			},
			getName:function(name) {
				if(!cachedName) {
					cachedName = storage.getItem(userName);
				}
				return cachedName || '';
			},
			getLastName:function(name) {
				if(!cachedLastName) {
					cachedLastName = storage.getItem(userLastName);
				}
				return cachedLastName || '';
			},
			getAvatar:function(avatar) {
				if(!cachedAvatar) {
					cachedAvatar = storage.getItem(userAvatar);
				}
				return cachedAvatar;
			},
			getAitools:function() {
				if(!cachedAitools) {
					cachedAitools = storage.getItem(aitools)? JSON.parse(storage.getItem(aitools)) : [];
				}
				return cachedAitools;
			},
			isAuthenticated:function() {
				return !!authToken.getToken(); //return true if get from getToken
			},
			removeToken: function() {
				cachedName = null;
				cachedAvatar =  null;
				cachedId =  null;
				cachedroleId = null;
				storage.removeItem(userAvatar);
				storage.removeItem(refreshToken);
				storage.removeItem(userName);
				storage.removeItem(userLastName);
				storage.removeItem(userToken);
				storage.removeItem(userId);
				storage.removeItem(roleId);
				storage.removeItem(aitools);
			}
		}
		return authToken;
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/authtokenService.js
// module id = 586
// module chunks = 0